// Copied from chakra-ui/menu, in all it's glory...
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable func-style */

import { useControllableState } from '@chakra-ui/hooks';
import { getValidChildren } from '@chakra-ui/react-utils';
import { addItem, isArray, isString, removeItem } from '@chakra-ui/utils';
import * as React from 'react';
import {
  IDropdownSelectionIndicatorAlignment,
  IDropdownSelectionIndicatorType,
  IDropdownSizes,
} from './DropdownTypes';
import { getFallbackValues } from './utils';

export interface IUseDropdownOptionGroup {
  value?: string[] | string;
  defaultValue?: string[] | string;
  type?: 'checkbox' | 'radio';
  onChange?: (value: string[] | string) => void;
  children?: React.ReactNode;
  // additions
  onOptionSelected?: (value: string[] | string, group: string) => void;
  selectionIndicator?: IDropdownSelectionIndicatorType;
  selectionIndicatorAlignment?: IDropdownSelectionIndicatorAlignment;
  size?: IDropdownSizes;
  isMultiple?: boolean;
  groupid?: string;
}

// based on useMenuOptionGroup
// added one additional method, onOptionSelected - for centrally managing selection-state
// pluss: decorator, decoratorAlignment, size, groupid
export function useDropdownOptionGroup(props: IUseDropdownOptionGroup = {}) {
  const {
    children,
    type = 'radio',
    value: valueProp,
    defaultValue,
    onChange: onChangeProp,
    onOptionSelected: onOptionSelectedProp = (_value: string[] | string, _group: string) => void {},
    selectionIndicator,
    selectionIndicatorAlignment,
    size,
    isMultiple,
    groupid,
    ...htmlProps
  } = props;

  const isRadio = type === 'radio';

  const fallback = isRadio ? '' : [];

  const [value, setValue] = useControllableState({
    defaultValue: defaultValue ?? fallback,
    value: valueProp,
    onChange: onChangeProp,
  });

  const onChange = React.useCallback(
    (selectedValue: string) => {
      if (type === 'radio' && isString(value)) {
        if (value === selectedValue) {
          // uncheck
          setValue('');
          onOptionSelectedProp('', groupid ?? 'no-group');
        } else {
          setValue(selectedValue);
          onOptionSelectedProp(selectedValue, groupid ?? 'no-group');
        }
      }

      if (type === 'checkbox' && isArray(value)) {
        const nextValue = value.includes(selectedValue)
          ? removeItem(value, selectedValue)
          : addItem(value, selectedValue);

        setValue(nextValue);
        onOptionSelectedProp(nextValue, groupid ?? 'no-group');
      }
    },
    [value, setValue, type]
  );

  const validChildren = getValidChildren(children);

  const clones = validChildren.map((child) => {
    /**
     * We've added an internal `id` to each `MenuItemOption`,
     * let's use that for type-checking.
     *
     * We can't rely on displayName or the element's type since
     * they can be changed by the user.
     */
    if ((child.type as any).id !== 'MenuItemOption') {
      return child;
    }

    const { text: childText = 'no-text', value: childValue = 'no-value' } = child.props;
    const fallbacks = getFallbackValues(childText, childValue, child.props.children);

    const onClick = (event: MouseEvent) => {
      onChange(fallbacks.value);
      child.props.onClick?.(event);
    };

    const isChecked =
      type === 'radio' ? fallbacks.value === value : value.includes(fallbacks.value);

    return React.cloneElement(child, {
      type,
      onClick,
      isChecked,
      size,
      selectionindicator: selectionIndicator,
      selectionindicatoralignment: selectionIndicatorAlignment,
      ismultiple: isMultiple?.toString(),
    });
  });

  return {
    ...htmlProps,
    children: clones,
  };
}
